import { Directive, ElementRef, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AccessDisableCheckType, AccessVisibilityCheckType } from '@app/models/common/common.model';

import { AccessGuard } from './access-guard';
import { AccesssMethods } from './access.model';

@Directive({
    // tslint:disable-next-line: directive-selector
    selector: '[accessVisibility]',
    standalone: false
})
export class AccessVisibilityDirective {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) { }

  @Input()
  set accessVisibility(val: AccessVisibilityCheckType | undefined) {
    if (val) {
      const accessMethod = AccessGuard.accessMethods[val.controllerKey];
      if (accessMethod === undefined || accessMethod.length === 0) {
        // Methods not loaded yet, OR transiently reset to empty during a
        // background token refresh / permission reload. An authenticated user
        // who can reach a controller always has a non-empty method list for it,
        // so an empty/missing list is never a genuine "deny" — it's an in-flight
        // state. Preserve the current view instead of tearing it down. This is
        // what made the licence switcher flicker away when a form was left idle:
        // the silent token refresh momentarily cleared accessMethods and the
        // directive hit the clear() branch before the list was repopulated.
        return;
      }
      if (
        val.ngIf !== false &&
        accessMethod.indexOf(AccesssMethods[val.controllerKey][val.methodKey]) > -1
      ) {
        if (this.viewContainer.length === 0) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        }
      } else if (!!val.else) {
        if (this.viewContainer.length === 0) {
          this.viewContainer.createEmbeddedView(val.else);
        }
      } else {
        this.viewContainer.clear();
      }
    } else {
      if (this.viewContainer.length === 0) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
    }
  }
}

@Directive({
    // tslint:disable-next-line: directive-selector
    selector: '[accessDisable]',
    standalone: false
})
export class AccessDisableDirective {
  constructor(private element: ElementRef) { }

  @Input()
  set accessDisable(val: AccessDisableCheckType | undefined) {
    if (val) {
      const accessMethod = AccessGuard.accessMethods[val.controllerKey];
      if (
        val.disable !== true && accessMethod &&
        accessMethod.indexOf(AccesssMethods[val.controllerKey][val.methodKey]) > -1
      ) { } else {
        this.element.nativeElement.disabled = true;
        this.element.nativeElement.classList.add('disabled');
      }
    }
  }
}
